var _path, _path2, _path3, _path4, _path5, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_27)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M29.46 14.72C29.462 17.6337 28.5998 20.4826 26.9824 22.9063C25.3651 25.3299 23.0652 27.2195 20.3739 28.3359C17.6825 29.4523 14.7205 29.7454 11.8625 29.1782C9.00446 28.611 6.37889 27.2089 4.31786 25.1492C2.25683 23.0896 0.852945 20.465 0.283774 17.6074C-0.285398 14.7497 0.0057143 11.7875 1.1203 9.0954C2.23488 6.40326 4.12286 4.10215 6.54542 2.48315C8.96797 0.864159 11.8163 6.71454e-07 14.73 0C18.6349 -8.9986e-07 22.38 1.55054 25.1421 4.31079C27.9043 7.07104 29.4574 10.8151 29.46 14.72Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.46 14.72C29.462 17.6337 28.5998 20.4826 26.9824 22.9063C25.3651 25.3299 23.0652 27.2195 20.3739 28.3359C17.6825 29.4523 14.7205 29.7454 11.8625 29.1782C9.00446 28.611 6.37889 27.2089 4.31786 25.1492C2.25683 23.0896 0.852945 20.465 0.283774 17.6074C-0.285398 14.7497 0.0057143 11.7875 1.1203 9.0954C2.23488 6.40326 4.12286 4.10215 6.54542 2.48315C8.96797 0.864159 11.8163 6.71454e-07 14.73 0C18.6349 -8.9986e-07 22.38 1.55054 25.1421 4.31079C27.9043 7.07104 29.4574 10.8151 29.46 14.72Z",
    fill: "url(#paint0_linear_33_27)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.48 9.63997C21.222 9.59934 20.9612 9.57928 20.7 9.57997C18.33 9.57997 16.47 11.18 14.7 12.96C12.96 11.18 11.1 9.57997 8.70004 9.57997C8.43886 9.57928 8.17804 9.59934 7.92004 9.63997C6.70687 9.82698 5.60067 10.442 4.80154 11.3737C4.00241 12.3055 3.56311 13.4925 3.56311 14.72C3.56311 15.9475 4.00241 17.1345 4.80154 18.0662C5.60067 18.998 6.70687 19.613 7.92004 19.8C8.17804 19.8406 8.43886 19.8607 8.70004 19.86C11.07 19.86 12.93 18.27 14.7 16.49C16.44 18.27 18.3 19.86 20.7 19.86C20.9612 19.8607 21.222 19.8406 21.48 19.8C22.6932 19.613 23.7994 18.998 24.5985 18.0662C25.3977 17.1345 25.837 15.9475 25.837 14.72C25.837 13.4925 25.3977 12.3055 24.5985 11.3737C23.7994 10.442 22.6932 9.82698 21.48 9.63997ZM8.76004 17.41C8.04661 17.41 7.3624 17.1266 6.85793 16.6221C6.35345 16.1176 6.07004 15.4334 6.07004 14.72C6.07004 14.0066 6.35345 13.3223 6.85793 12.8179C7.3624 12.3134 8.04661 12.03 8.76004 12.03C10.22 12.03 11.6 13.25 13.04 14.72C11.6 16.19 10.22 17.41 8.76004 17.41ZM20.7 17.41C19.25 17.41 17.86 16.19 16.43 14.72C17.86 13.25 19.25 12.03 20.7 12.03C21.4135 12.03 22.0977 12.3134 22.6022 12.8179C23.1066 13.3223 23.39 14.0066 23.39 14.72C23.39 15.4334 23.1066 16.1176 22.6022 16.6221C22.0977 17.1266 21.4135 17.41 20.7 17.41Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.73 12.96C14.2816 12.4844 13.8076 12.0338 13.31 11.61C13.01 11.91 12.71 12.23 12.42 12.53L11.62 13.37C12.09 13.77 12.56 14.23 13.04 14.72L13.84 13.88C14.14 13.57 14.43 13.26 14.73 12.96Z",
    fill: "url(#paint1_linear_33_27)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.73 16.49C15.19 16.96 15.66 17.42 16.15 17.84L17.04 16.91L17.84 16.07C17.37 15.67 16.9 15.21 16.43 14.72L15.62 15.56L14.73 16.49Z",
    fill: "url(#paint2_linear_33_27)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M29.46 14.72C29.462 17.6337 28.5998 20.4826 26.9824 22.9063C25.3651 25.3299 23.0652 27.2195 20.3739 28.3359C17.6825 29.4523 14.7205 29.7454 11.8625 29.1782C9.00446 28.611 6.37889 27.2089 4.31786 25.1492C2.25683 23.0896 0.852945 20.465 0.283774 17.6074C-0.285398 14.7497 0.0057143 11.7875 1.1203 9.0954C2.23488 6.40326 4.12286 4.10215 6.54542 2.48315C8.96797 0.864159 11.8163 6.71454e-07 14.73 0C18.6349 -8.9986e-07 22.38 1.55054 25.1421 4.31079C27.9043 7.07104 29.4574 10.8151 29.46 14.72Z",
    fill: "url(#paint3_radial_33_27)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.48 9.63997C21.222 9.59934 20.9612 9.57928 20.7 9.57997C18.33 9.57997 16.47 11.18 14.7 12.96C12.96 11.18 11.1 9.57997 8.70004 9.57997C8.43887 9.57957 8.17808 9.59963 7.92004 9.63997C6.70687 9.82698 5.60067 10.442 4.80154 11.3737C4.00241 12.3055 3.56311 13.4925 3.56311 14.72C3.56311 15.9475 4.00241 17.1345 4.80154 18.0662C5.60067 18.998 6.70687 19.613 7.92004 19.8C8.17808 19.8403 8.43887 19.8604 8.70004 19.86C11.07 19.86 12.93 18.27 14.7 16.49C16.44 18.27 18.3 19.86 20.7 19.86C20.9612 19.8607 21.222 19.8406 21.48 19.8C22.6932 19.613 23.7994 18.998 24.5985 18.0662C25.3977 17.1345 25.837 15.9475 25.837 14.72C25.837 13.4925 25.3977 12.3055 24.5985 11.3737C23.7994 10.442 22.6932 9.82698 21.48 9.63997ZM8.76004 17.41C8.04661 17.41 7.3624 17.1266 6.85793 16.6221C6.35345 16.1176 6.07004 15.4334 6.07004 14.72C6.07004 14.0066 6.35345 13.3223 6.85793 12.8179C7.3624 12.3134 8.04661 12.03 8.76004 12.03C10.22 12.03 11.6 13.25 13.04 14.72C11.6 16.19 10.22 17.41 8.76004 17.41ZM20.7 17.41C19.25 17.41 17.86 16.19 16.42 14.72C17.86 13.25 19.25 12.03 20.7 12.03C21.4135 12.03 22.0977 12.3134 22.6022 12.8179C23.1066 13.3223 23.39 14.0066 23.39 14.72C23.39 15.4334 23.1066 16.1176 22.6022 16.6221C22.0977 17.1266 21.4135 17.41 20.7 17.41Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.73 12.96C14.2816 12.4844 13.8076 12.0338 13.31 11.61L12.42 12.53L11.62 13.37C12.09 13.77 12.56 14.23 13.04 14.72L13.84 13.88C14.14 13.57 14.43 13.26 14.73 12.96Z",
    fill: "url(#paint4_linear_33_27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.73 16.49C15.19 16.96 15.66 17.42 16.15 17.84L17.04 16.91L17.84 16.07C17.37 15.67 16.9 15.21 16.43 14.72L15.62 15.56L14.73 16.49Z",
    fill: "url(#paint5_linear_33_27)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_27",
    x1: 0.00000321492,
    y1: 14.72,
    x2: 29.46,
    y2: 14.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33_27",
    x1: 12.46,
    y1: 12.45,
    x2: 17,
    y2: 16.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33_27",
    x1: 12.46,
    y1: 12.46,
    x2: 17,
    y2: 16.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_33_27",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.73 14.72) scale(14.73 14.73)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_33_27",
    x1: 12.47,
    y1: 12.45,
    x2: 17,
    y2: 16.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_33_27",
    x1: 12.46,
    y1: 12.46,
    x2: 17,
    y2: 16.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.45,
    height: 29.45,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBig);
export default __webpack_public_path__ + "static/media/logo_big.63366df052813719c3501d58bf6593c4.svg";
export { ForwardRef as ReactComponent };